import { SecondaryButton } from '@designsforhealth/dfh-react-components'
import Grid from '@material-ui/core/Grid'
import styled from 'styled-components'

export const StyledGrid = styled(Grid)`
  background-color: ${({ theme }) => theme.colors.grayscale.white};
  padding: 10px;
  position: relative;
`

export const Button = styled(SecondaryButton)`
  width: 100%;
  height: 100px;
  max-height: 100px;
  background-color: ${({ theme }) => theme.colors.coolGray.cool150};
  border-radius: 8px;
  border: 2px solid transparent;
  &.selected {
    border-color: ${({ theme }) => theme.colors.brand.orange};
  }
`

export const ParagraphText = styled.div`
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  letter-spacing: unset;
  text-transform: none;
  font-weight: 400;
`

export const ButtonText = styled(ParagraphText)`
  background-color: ${({ theme }) => theme.colors.coolGray.cool250};
  color: ${({ theme }) => theme.colors.component.SecondaryButton.default.text};
  border-radius: 8px;
  padding: 10px;
  margin-top: 5px;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
`

export const IconContainer = styled.div`
  height: 100px;
  margin-top: -92px;
  width: 100%-8px;
  margin-left: 8px;
  color: transparent;
  &.selected {
    color: ${({ theme }) => theme.colors.brand.orange};
  }
`

export const LastIconContainer = styled(IconContainer)`
  height: 92px;
`
